import { Button, spacing, Text } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

import { SignupForm } from "./-signup-form"

export const Route = createFileRoute("/signup/")({
  component: Signup,
})

function Signup() {
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Create account")}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <SignupForm />
    </PageLayout>
  )
}

function Footer() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <div>
      <Text variant="bodyS" color="secondary" marginBottom={spacing.XS}>
        {tPlaceholder("Already have an account?")}{" "}
        <Button
          variant="minimal"
          color="neutral"
          size="small"
          onClick={() => {
            void navigate({ to: "/login" })
          }}
        >
          {tPlaceholder("Sign in")}
        </Button>
      </Text>

      <Text variant="bodyS" color="secondary" marginBottom={spacing.XS}>
        <Button
          variant="minimal"
          color="neutral"
          size="small"
          onClick={() => {
            void navigate({ to: "/password/reset" })
          }}
        >
          {tPlaceholder("Forgot your password?")}
        </Button>
      </Text>
    </div>
  )
}
